import { ExpirationDateType } from 'pages/Admin/AdminTools/ExpirationDateType'
import { useEffect, useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { UnderwritingSummaryConfig } from '../UnderwritingSummary'

const tabs = {
  summary: 'Underwriting Summary',
  expiration: 'Expiration Dates',
}

export const UnderwritingConfig = ({ initialTab }: { initialTab?: string }) => {
  const [tab, setTab] = useState(initialTab === 'expiration' ? 'expiration' : 'summary')

  useEffect(() => {
    if (initialTab === 'expiration') setTab('expiration')
  }, [initialTab])

  return (
    <div>
      <ButtonGroup title={tabs} value={tab} onChange={setTab} />
      <div className="mt-4">{tab === 'expiration' ? <ExpirationDateType /> : <UnderwritingSummaryConfig />}</div>
    </div>
  )
}
